// extracted by mini-css-extract-plugin
module.exports = {"rippleContainer":"E8ZkJ","pinkBg":"_2Hum7","ripple":"_1HZ7b"};